export const CLOUDINARY_CLOUD_NAME = 'fit-society';
export const CLOUDINARY_PUBLIC_PRESET_NAME = 'unsigned';
export const SALT_ROUNDS = 8;
export const HOST =
  process.env.HOST ?? (process.env.NODE_ENV === 'production' ? 'https://fitsociety.com' : 'http://localhost:3000');
